import React, { useState, FC, FocusEvent, ChangeEvent } from 'react';

import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms/types';
import { StringInputViewModel } from '@sitecore-jss/sitecore-jss-forms';
import Icon from '../../../@shared/icon';
import useFirstUserAction from '../../hooks/useFirstUserActionState';
import CustomTextLabel from '../@shared/customTextLabel';

const PasswordField: FC<ValueFieldProps<StringInputViewModel>> = (props) => {
  const { field, tracker } = props;
  const [hasFocus, setHasFocus] = useState(false);
  const [hasVisiblePassword, setHasVisiblePassword] = useState(false);
  const [value, setValue] = useState(props.value);
  const hasValueOrFocus = hasFocus || value !== '';
  const hasAnyError = !!props.errors?.length;
  const id = field.valueField.id;
  const label = field.model.title;
  const name = field.valueField.name;
  const FieldValidationErrors = props.fieldValidationErrorsComponent;
  const triggerFirstInteractionGTMEvent = useFirstUserAction();

  const onFocus = (e: FocusEvent<HTMLInputElement>): void => {
    tracker.onFocusField(field, e?.target?.value);
    setHasFocus(true);
  };

  const onBlur = (e: FocusEvent<HTMLInputElement>): void => {
    tracker.onBlurField(field, e?.target?.value);
    setHasFocus(false);
  };

  const onChange = (e: ChangeEvent<HTMLInputElement>): void => {
    setValue(e?.target?.value);
    props.onChange(field.valueField.name, e?.target?.value, props.isValid, []);
    triggerFirstInteractionGTMEvent();
  };

  return (
    <div
      className={`sitecore-jss-form__control sitecore-jss-form__control--text-box ${
        hasAnyError ? 'sitecore-jss-form__control--has-error' : ''
      }`}
    >
      <label htmlFor={id} className={`sitecore-jss-form__label ${hasValueOrFocus ? 'sitecore-jss-form__label--has-focus' : ''}`}>
        <CustomTextLabel label={label} />
      </label>
      <input
        id={id}
        name={name}
        className="sitecore-jss-form__field"
        type={`${hasVisiblePassword ? 'text' : 'password'}`}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChange}
        value={props.value}
      />
      <button
        type="button"
        className="sitecore-jss-form__toggle-password-visibility-btn"
        onClick={(): void => setHasVisiblePassword(!hasVisiblePassword)}
      >
        <Icon iconName={hasVisiblePassword ? 'action-eye-off' : 'action-eye-on'} size={24} />
      </button>
      {FieldValidationErrors && <FieldValidationErrors {...props} />}
    </div>
  );
};

export default PasswordField;
